import { BaseModel } from './base.model';
import { Picture } from './picture.model';
import { Destination } from './destination.model';
import { Section } from './section.model';
import { Comment } from './comment.model';
import { Tag } from './tag.model';
import { StickyLink } from './sticky-link.model';

export class Article extends BaseModel {
  name: string;
  place?: string;
  destinationId?: string;
  destination?: Destination;
  date: Date;
  coverPictureId: string;
  coverPicture?: Picture;
  sections?: Section<any>[];
  description: string;
  draft: boolean;
  comments: Comment[];
  tags: Tag[];
  slug: string;
  lat: string;
  lng: string;
  seoDescription: string;
  articleType: ArticleType;
  hasSummary: boolean;
  stickyLinks: StickyLink[];
  stickyLinksTitle: string;
  category: ArticleCategory;

  constructor() {
    super();
    this.description = '';
    this.seoDescription = '';
    this.stickyLinksTitle = '';
    this.stickyLinks = [];
  }
}

export class ArticleSearchModel {
  searchWord: string;
  destinationId?: string;
  tags?: Tag[];
  articleType?: ArticleType;
}

export enum ArticleType {
  Article,
  Accommodation,
  Setup,
}

export enum ArticleCategory {
  RoadTrip,
  CityTrip,
  Hiking,
}
